import { ThemeProvider, Theme, CssBaseline } from '@material-ui/core'
import React, { ReactNode } from 'react'
import { CookiesProvider } from 'react-cookie'
import { IntlProvider } from 'react-intl'
import PlausibleProvider from 'next-plausible'

export type SharedProvidersProps = {
  theme: Theme
  requiredRoles?: string[]
  children: ReactNode
}

const SharedProviders: React.FC<SharedProvidersProps> = ({
  children,
  theme,
}) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookiesProvider>
          {/* To test locally add the props `enabled` and `trackLocalhost` */}
          <PlausibleProvider
            domain="funds.effectivealtruism.org"
            trackOutboundLinks
            taggedEvents
          >
            <IntlProvider locale="en-US">{children}</IntlProvider>
          </PlausibleProvider>
        </CookiesProvider>
      </ThemeProvider>
    </>
  )
}

export default SharedProviders
